import * as React from "react";

/** Practice quiz icon — checklist with check/cross marks, used for 練習問題 section */
export const IconPracticeQuiz = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#clip0_practice_quiz)">
      <path
        d="M16.54 11.0002L13 7.46018L14.41 6.05018L16.53 8.17018L20.77 3.93018L22.18 5.34018L16.54 11.0002ZM11 7.00018H2V9.00018H11V7.00018ZM21 13.4102L19.59 12.0002L17 14.5902L14.41 12.0002L13 13.4102L15.59 16.0002L13 18.5902L14.41 20.0002L17 17.4102L19.59 20.0002L21 18.5902L18.41 16.0002L21 13.4102ZM11 15.0002H2V17.0002H11V15.0002Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_practice_quiz">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
